(function () {
  'use strict';

  var CART_ROUTE = window.Shopify && window.Shopify.routes
    ? window.Shopify.routes.root + 'cart'
    : '/cart';

  function request(endpoint, options) {
    return fetch(CART_ROUTE + endpoint + '.js', Object.assign({
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    }, options))
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      });
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent('ft:cart:' + name, { detail: detail, bubbles: true }));
  }

  window.FtCart = {
    get: function () {
      return fetch(CART_ROUTE + '.js', {
        headers: { 'Accept': 'application/json' }
      }).then(function (res) { return res.json(); });
    },

    add: function (items) {
      return request('/add', { body: JSON.stringify({ items: items }) })
        .then(function (data) {
          emit('added', data);
          return window.FtCart.get();
        })
        .then(function (cart) {
          emit('updated', cart);
          return cart;
        });
    },

    update: function (updates) {
      return request('/update', { body: JSON.stringify({ updates: updates }) })
        .then(function (cart) {
          emit('updated', cart);
          return cart;
        });
    },

    change: function (line, quantity) {
      return request('/change', { body: JSON.stringify({ line: line, quantity: quantity }) })
        .then(function (cart) {
          emit('updated', cart);
          return cart;
        });
    },

    clear: function () {
      return request('/clear', { body: JSON.stringify({}) })
        .then(function (cart) {
          emit('updated', cart);
          return cart;
        });
    }
  };
})();
